import { SelectProps } from 'antd/es/select'
import { Dayjs } from 'dayjs'
import { FC } from 'react'
import { RentalMachinerySelector } from '@/presentation/rentals/components/RentalMachinerySelector.tsx'

export const FuelRegistryMachinerySelector: FC<SelectProps & { date: Dayjs }> = ({ date, ...props }) => {
  return (
    <RentalMachinerySelector {...props} filters={{
      date: date.startOf('day').toISOString(),
    }} />
  )
}
